import React from "react";

type CaretRightIconProps = {
  className?: string;
};

export default function CaretRightIcon({ className }: CaretRightIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={`caret-icon${className ? ` ${className}` : ''}`}
    >
      <path d="M9 6l6 6-6 6V6z" />
    </svg>
  );
}
